import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.headerText':{
    fontWeight:'bold',
    fontSize:'1.2rem',
    color:`${v.ezMainColor}`
  },
  
  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },

  '.amountCont':{
    marginTop:'1rem',
    alignSelf:'flex-end',

    display:'flex',
    '.header':{
      fontWeight:'bold',
      // fontSize:'1.2rem'
    },
    '.data':{
      '.centerContent':{
        // fontSize:'1.2rem',
      },
      textAlign:'end',
      minWidth:'10rem',
      paddingRight:'0.625rem'
    }
  },

  '.checkBox': {
    display: 'flex',
    flexDirection:'column',

    '.header':{
      color:'#888888',
      marginBottom:'0.5rem',
      'span':{
        color:'red'
      }
    },
    
    '.checkGroup':{
      display: 'flex',
      '>div':{
        flex: 'none',
      }
    }
  },
})
